import { render } from "./ModalFileManager.vue?vue&type=template&id=6c5436f5&scoped=true"
import script from "./ModalFileManager.vue?vue&type=script&lang=js"
export * from "./ModalFileManager.vue?vue&type=script&lang=js"

import "./ModalFileManager.vue?vue&type=style&index=0&id=6c5436f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5436f5"]])

export default __exports__